import { observer } from 'mobx-react'
import React, { useContext, useEffect, useState } from 'react'

import 'primereact/resources/themes/arya-blue/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import PrimeReact from 'primereact/api'

import 'react-toastify/dist/ReactToastify.css'
import { firstWorldCountries } from './setWorld'
import { PlansWorkspace, PlansWorkspaceContext } from './PlansWorkspace'
import { Card } from 'primereact/card'
import { Button } from 'primereact/button'
import { WorkSpaceContext } from '../stores/WorkSpace'
import { Chip } from 'primereact/chip'
import { ProgressSpinner } from 'primereact/progressspinner'
import { SelectButton } from 'primereact/selectbutton'
import { goToExternalLink } from '../screens/helpers/clicks'
import { isTablet, isMobile, isMobileOnly } from 'react-device-detect'

PrimeReact.ripple = true

const PlansContainer: React.FC = observer(() => {
    const plansWorkspace = useContext<PlansWorkspace>(PlansWorkspaceContext)
    //   const uiStatus = rootStore.uiStatus;

    useEffect(() => {
        plansWorkspace.hydrateDataFromPage()
    }, [])

    // const monthlyCostAmount = (plan) => {
    //   let number = null;
    //   if (plansWorkspace.isThirdWorld) {
    //     number = plan["monthly_price_world_three"];
    //   } else {
    //     number = plan["monthly_price_world_one"];
    //   }
    //   return "$" + number + " USD";
    // };

    const makeButtonClassName = (quality) => {
        if (quality == 'good') {
            return 'p-button-secondary'
        }
        if (quality == 'better') {
            return 'p-button-success'
        }
        if (quality == 'best') {
            return 'p-button-help'
        }
    }

    const makeSubscriptionCardWidth = () => {
        if (isMobileOnly) {
            return '70vw'
        }
        if (isTablet) {
            return '28vw'
        }
        return '18em'
    }

    const makePlanSetsForDisplay = () => {
        if (isMobileOnly) {
            const acc = []
            acc[0] = 'Starter Plans'
            acc[1] = 'Professional Plans'
            return acc
        }
        return plansWorkspace.planSets
    }

    const makePlanSetsValue = () => {
        if (isMobileOnly) {
            if (plansWorkspace.product == 'starter') {
                return 'Starter Plans'
            } else {
                return 'Professional Plans'
            }
        }

        if (plansWorkspace.product == 'starter') {
            return 'Starter (2000 Predictions)'
        } else {
            return 'Professional (6000 Predictions)'
        }
    }

    const makeSubscriptionCardMargin = () => {
        if (isMobileOnly) {
            return 'mt-4'
        }
        if (isTablet) {
            return 'mr-1'
        }
        return 'mr-4'
    }

    const product = plansWorkspace.currentProduct
    const world = plansWorkspace.world

    const header = (
        <img
            className="subscription-card-image"
            alt="Card"
            src="https://d2v712bu19fw8r.cloudfront.net/images/SpeedwriteICONWhite-Trans.png"
        />
    )

    const makeHeader = () => {
        if (isMobileOnly) {
            return null
        }
        return header
    }

    return (
        <>
            <p className="title is-2">Subscribe To Speedwrite</p>
            <p className="subtitle is-4">
                Get More Predictions &nbsp;
                <i className="fa fa-arrow-alt-right"></i>
            </p>
            {plansWorkspace.shouldShowPlans == false && (
                <div>
                    <ProgressSpinner />
                </div>
            )}
            {plansWorkspace.shouldShowPlans && (
                <>
                    {/* <div className="buttons ">
                        <SelectButton
                            value={makePlanSetsValue()}
                            options={makePlanSetsForDisplay()
                            onChange={(e) => plansWorkspace.togglePlanSet()}
                            className=" "
                        />
                    </div> */}

                    <div className="flex flex-wrap justify-content-left">
                        {plansWorkspace.currentProduct.price_indexes.map(
                            (index) => {
                                return (
                                    <div className="p-mr-2" key={index}>
                                        <Card
                                            className={
                                                'subscription-card-' +
                                                product.qualities[index] +
                                                ' ' +
                                                makeSubscriptionCardMargin()
                                            }
                                            title={product.price_titles[
                                                index
                                            ].replace(' Pro', '')}
                                            subTitle={
                                                product.save_percent[world][
                                                    index
                                                ]
                                            }
                                            style={{
                                                width: makeSubscriptionCardWidth(),
                                            }}
                                            //footer={footer}
                                            header={makeHeader()}
                                        >
                                            <strong>
                                                <p className="plan-award">
                                                    {product.award[index]}{' '}
                                                </p>
                                            </strong>
                                            <p className="p-m-0">
                                                {
                                                    product.monthly_predictions_allowed
                                                }{' '}
                                                predictions per month
                                            </p>
                                            <p
                                                className="p-m-0"
                                                style={{ lineHeight: '1.5' }}
                                            >
                                                <strong>
                                                    {'$' +
                                                        product.monthly_prices[
                                                            world
                                                        ][index] +
                                                        ' '}{' '}
                                                </strong>
                                                {product.price_tags[index]}
                                            </p>
                                            <p
                                                className="p-m-0 long-term-cost"
                                                style={{ lineHeight: '1.5' }}
                                            >
                                                {
                                                    product.price_details[
                                                        world
                                                    ][index]
                                                }
                                            </p>

                                            <span>
                                                <Button
                                                    label="Subscribe Now"
                                                    // disabled={
                                                    //   plansWorkspace.plansData.data
                                                    //     .currentUserSubscriptionPlan != null
                                                    // }
                                                    className={
                                                        makeButtonClassName(
                                                            product.qualities[
                                                                index
                                                            ]
                                                        ) + ' mt-3'
                                                    }
                                                    icon="pi pi-check"
                                                    onClick={(e) =>
                                                        plansWorkspace.handleSubscriptionButtonClick(
                                                            e,
                                                            product,
                                                            index
                                                        )
                                                    }
                                                />
                                            </span>
                                        </Card>
                                    </div>
                                )
                            }
                        )}
                    </div>
                    <p className="has-text-grey mt-1">
                        All prices are in U.S. dollars. Your subscription will
                        automatically renew every month (monthly), every six
                        months (semi-annual), or every year (annual) until you
                        cancel. You many cancel your subscription at any time.
                        If you cancel your subscription, you will no longer be
                        charged, but your prior payment(s) will not be refunded.
                        Annual and semi-annual plans are billed today for the
                        full annual or semi-annual amount. By subscribing, you
                        agree to the terms of service linked on this page, as
                        well as these additional subscription terms:
                    </p>
                    <div className="buttons mt-2">
                        <Button
                            label="Speedwrite Subscriptions Terms & FAQ"
                            className={'p-button p-button-text'}
                            icon="pi pi-info-circle"
                            onClick={(e) =>
                                goToExternalLink(
                                    e,
                                    '/subscription_terms',
                                    false
                                )
                            }
                        />
                    </div>
                    {/* <div className=""></div> */}
                    <hr />
                    <p className="title is-2">Why subscribe?</p>
                    <p className="subtitle is-5 subscriptions-feature-subtitle  mt-2">
                        Trusted by hundreds of thousands of users &nbsp;
                        <i className="fa fa-arrow-alt-right"></i>
                    </p>
                    <div className="flex  flex-wrap">
                        <Chip
                            icon="pi pi-check-circle"
                            label="No surprise charges"
                            className="mr-2 mb-2"
                        />
                        <Chip
                            icon="pi pi-check-circle"
                            label="Clear billing terms"
                            className="mr-2 mb-2"
                        />
                        <Chip
                            icon="pi pi-check-circle"
                            label="Cancel Any Time"
                            className="mr-2 mb-2"
                        />
                    </div>

                    <p className="subtitle is-5 subscriptions-feature-subtitle  mt-2">
                        All Speedwrite Subscriptions &nbsp;
                        <i className="fa fa-arrow-alt-right"></i>
                    </p>
                    <div className="flex flex-wrap">
                        <Chip
                            icon="pi pi-check-circle"
                            label="Unlimited Exports"
                            className="mr-2 mb-2"
                        />
                        <Chip
                            icon="pi pi-check-circle"
                            label="Unlimited Editing"
                            className="mr-2 mb-2"
                        />
                        <Chip
                            icon="pi pi-check-circle"
                            label="High-speed predictions"
                            className="mr-2 mb-2"
                        />
                    </div>
                    <p className="subtitle is-5 subscriptions-feature-subtitle mt-2">
                        Our Privacy Commitment &nbsp;
                        <i className="fa fa-arrow-alt-right"></i>
                    </p>
                    <div className="flex p-ai-center flex-wrap">
                        <Chip
                            icon="pi pi-check-circle"
                            label="Your source text is private"
                            className="mr-2 mb-2"
                        />
                        <Chip
                            icon="pi pi-check-circle"
                            label="Your predictions are private"
                            className="mr-2 mb-2"
                        />
                        <Chip
                            icon="pi pi-check-circle"
                            label=" Delete your documents at any time"
                            className="mr-2 mb-2"
                        />
                    </div>
                    <p className="subtitle is-5 subscriptions-feature-subtitle mt-2">
                        Includes Free Access To Speedwrite Creative &nbsp;
                        <i className="fa fa-arrow-alt-right"></i>
                    </p>
                    <div className="flex p-ai-center flex-wrap">
                        <Chip
                            icon="pi pi-check-circle"
                            label="6000 additional Speedwrite Creative predictions "
                            className="mr-2 mb-2"
                        />
                    </div>
                </>
            )}
        </>
    )
})

export default PlansContainer
